// ---------------------------------------------------------------------------
// 設定のメニューと自社（発行者）情報（iOS 風、#153、docs/62）の画面の文言。
// 行の名前（振込口座・端数処理 など）は今までの設定のメニューと同じ。言葉の置き換え（{trade}・{schedule}）は画面の t() が通す
// ---------------------------------------------------------------------------

export const SETTINGS_MSG = {
  title: "設定",
  /** 頭の行の下の字（管理者：押すと自社情報） */
  companyRowSub: "自社（発行者）情報",
  /** 担当者の注（docs/62 §2。今の長い文はやめる） */
  memberNote: "会社の設定は管理者が変えます",
  closeNote: "30日以内なら戻せます",
  sectionCompany: "会社",
  sectionEstimate: "見積・請求",
  sectionWords: "項目と言葉",
  sectionSchedule: "{schedule}",
  /** 担当者の節 */
  sectionMemberEstimate: "見積",
  usersCount: "{n}人",

  // ---- 自社（発行者）情報（docs/62 §3）----
  companyTitle: "自社（発行者）情報",
  save: "保存",
  saving: "保存中…",
  saved: "設定を保存しました。",
  /**
   * 自社情報は自動で保存（S-00008。題の右＝前の「保存」の場所に出す）。**上の帯の右は1行に収まる短い定型句だけ**（S-00009、docs/10 §5.1.2・§9.20）：
   * 自動保存／保存中…／保存しました 10:31／⚠ 保存できません／会社名が未入力。長い説明は題の下の1行（…Note）
   */
  autoSaveNote: "自動保存",
  autoSaving: "保存中…",
  autoSaved: "保存しました {at}",
  autoSaveFailed: "⚠ 保存できません",
  /** 会社名が空のあいだは送れない（PUT /company は会社名が要る）。上に赤い知らせは出さず、題の右（短く）と題の下の1行（説明）で言う */
  autoSaveNeedName: "会社名が未入力",
  autoSaveNeedNameNote: "会社名を入れると保存されます",
  /** 自社情報のほかの設定の画面で、会社名がまだ無い会社（PUT /company は会社名が要る） */
  autoSaveNoName: "会社名が未入力",
  autoSaveNoNameNote: "先に自社情報で会社名を入れてください",
  name: "会社名",
  representative: "代表者名",
  fiscalYear: "会計年度の始まり",
  representativeNote: "代表者名は会社名の下に印字されます",
  sectionImages: "社印とロゴ",
  seal: "社印（角印）",
  logo: "会社ロゴ",
  imageChange: "変更",
  imageNone: "未登録",
  imagePick: "画像選択",
  imageRemove: "削除",
  imageCancel: "取消",
  imageBusy: "登録しています…",
  imageResized: "画像が大きかったので、{w}×{h}px に縮めて登録しました",
  sectionAddress: "住所と連絡先",
  sectionInvoice: "インボイス",
  regNo: "登録番号",
  regNoNote: "登録していなければ空のまま",
  sectionBank: "振込先",
  bank: "振込口座",
  bankNone: "未登録",

  // ---- 見積・請求（docs/62 §4 で移した9つ → #154、docs/63 §2 で iOS 風に。節は仕事の順）----
  sectionCreate: "見積を作るとき",
  sectionLumpsum: "内訳のない一式の知らせ（社内用）",
  sectionVendor: "{vendorQuote}からの取込",
  sectionPdf: "見積書の PDF と印刷",
  sectionUnissue: "出した見積・請求書",
  sectionPayment: "入金",
  /** 行の名前（短く。長い説明は節の見出しの「？」へ。docs/63 §2） */
  axis: "既定の表示順",
  lumpsumPct: "税抜合計の割合",
  lumpsumYen: "金額",
  margin: "粗利率の既定",
  discount: "値引きにする上限",
  pageBreak: "内訳ごとに改ページ",
  ditto: "前の行と同じ{lineName}を「〃」",
  scopeNotes: "別途の一覧を備考に印字",
  takeoffSheet: "{takeoffSheet}の添付",
  unissue: "取消しして下書きに戻せる",
  /** 節の注（1行） */
  lumpsumNote: "どちらかを超える一式の行を、見積の画面で知らせます",
  unissueNote: "取り消した記録は残ります",
  paymentNote: "入金が足りないとき、請求書1枚あたりこの額まで値引きにできます",
  /** 会社名がまだ無い会社（PUT /company は会社名が要る） */
  needCompanyName: "会社名がまだ無いので保存できません。先に自社（発行者）情報で会社名を入れてください",
} as const;

/**
 * PC版の設定の2列（docs/62 §6）で、左の列のどの行をいまの行にするか。
 *   /settings/company＝頭の行、下の画面（/settings/bank-accounts/new など）はその親の行、
 *   {trade}・場所・品目の3つのタブ（/settings/trades・places・items）は1つの行
 */
export function settingsRowOf(pathname: string): string | null {
  const m = /^\/settings\/([^/]+)/.exec(pathname);
  if (!m) return null;
  const seg = m[1]!;
  if (seg === "places" || seg === "items") return "/settings/trades";
  return `/settings/${seg}`;
}

/** 2列の右の画面で「‹ 設定」を出さない画面（左の列が戻り道。docs/62 §6）＝左の列に行がある画面。その下の画面（口座の追加など）は出す */
export const isSettingsTopPath = (pathname: string): boolean => /^\/settings(\/[^/]+)?\/?$/.test(pathname);
